import type { ReportIssueContext } from "@/lib/feedback/types";

export const GLOBAL_ERROR_EVENT = "repackify:global-error";

export interface GlobalErrorDetail {
  message: string;
  code?: string;
  reportContext?: ReportIssueContext;
  reportable?: boolean;
}

export function isGlobalErrorDetail(value: unknown): value is GlobalErrorDetail {
  return (
    typeof value === "object" &&
    value !== null &&
    "message" in value &&
    typeof value.message === "string"
  );
}

export function showGlobalError(detail: GlobalErrorDetail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<GlobalErrorDetail>(GLOBAL_ERROR_EVENT, { detail }),
  );
}
